export default {
    LABEL: 'Tabs 标签页',
    DESC: '分隔内容上有关联但属于不同类别的数据集合。',
};
